module.exports = __webpack_public_path__ + "img/clubedomolho.90fd12e9.png";